module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "iview",
    staticStyle: {
      "height": "100%",
      "width": "100%"
    },
    attrs: {
      "id": "app"
    }
  }, [_c(_vm.which_to_show, {
    tag: "component"
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-be4e3b54"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 1086
// module chunks = 1